import React from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import Description from '../Metiral/Description'
import { useAuth } from '../../Context/ContextProvider'
import CustomTooltip from '../Metiral/CustomTooltip'
import noData from '../../Assete/notFound.svg'
import { HiOutlineMapPin } from "react-icons/hi2";
const getPaginationRange = (currentPage, totalPages) => {
  if (!totalPages || totalPages <= 7) {
    return Array.from({ length: totalPages || 0 }, (_, i) => i + 1);
  }

  const current = Number(currentPage) || 1;
  const total = Number(totalPages);
  const pages = new Set();

  // Always keep last 2 pages
  pages.add(total - 1);
  pages.add(total);

  if (current < 5) {
    // Start: 1 2 3 4 5 ... last-1 last
    for (let i = 1; i <= 5; i++) pages.add(i);
  } else {
    // From current: 1 ... current current+1 ... current+4 ... last-1 last
    pages.add(1);
    let start = current;
    let end = Math.min(current + 4, total - 2);
    // Keep a full 5-page window near the end
    if (end - start < 4) {
      start = Math.max(2, end - 4);
    }
    for (let i = start; i <= end; i++) pages.add(i);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push('...');
    }
    result.push(sorted[i]);
  }
  return result;
};

function JobLisit({ jobList, pagination }) {
  const navigate = useNavigate()
  const { objectToQueryString, loading } = useAuth()
  const gotToNextPage = (data) => {
    const queryString = objectToQueryString(data);
    navigate(`/find-new-job?${queryString}`, { replace: true });
  }
  const pageNumbers = getPaginationRange(Number(pagination?.current_page) || 1, Number(pagination?.total_pages) || 0);
  return (
    <section className="recent-job-area recent-job-inner-area">
      <div className="container">
        {loading ? <div className='d-flex justify-content-center align-items-center'>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div> : <>
          {jobList?.length > 0 ? <div className="row">
            {jobList?.map((item) => {
              return (
                <div className="col-md-4 col-lg-3">
                  <Link to={`/job-detail/${item?._id}`}>

                    <div className="recent-job-item recent-job-item recent-job-style2-item">
                      <div className="company-info">

                        <div className="content">
                          <CustomTooltip
                            title={item?.title}
                            placement="top"
                          >
                            <h4 className="name">{item?.title}</h4>
                          </CustomTooltip>
                          <h3 className="job_card_name">{item?.hospital_name}</h3>

                          {/* <h4 className="name">{item?.collageUniversty}</h4> */}
                          <p className="address"><HiOutlineMapPin /> {item?.city_code}</p>

                        </div>
                      </div>
                      <div className="main-content">
                        <h5 className="work-type">{item?.job_type}</h5>
                        {/* <p className="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p> */}
                      </div>
                      <p className="desc">
                        {/* <div dangerouslySetInnerHTML={{ __html: item?.scholarshipDescription }} /> */}
                        <Description letters={100} content={item?.description} />
                      </p>
                      <div className="recent-job-info">
                        <a className='btn-theme btn-sm' href={item?.web_link} target="_blank">View Detail</a>
                        {/* <Link className="btn-theme btn-sm" to="/job-detail"></Link> */}
                      </div>
                    </div>
                  </Link>
                </div>
                // <div className="col-md-4 col-lg-3 h-100">
                //   {/*== Start Recent Job Item ==*/}
                //   <Link className='text-decoration-none' to={`/job-detail/${item?._id}`}>

                //   <div className="recent-job-item recent-job-item recent-job-style2-item">
                //     <div className="company-info">

                //       <div className="content">
                //         <CustomTooltip
                //         title={item?.title}
                //         placement='top'>
                //         <h3 className="title job_card_title">{item?.title}</h3>

                //         </CustomTooltip>
                //     <h4 className="name job_card_name">{item?.hospital_name}</h4>
                //         <p className="address">{item?.city?.city}, Pakistan</p>
                //       </div>
                //     </div>
                //     <div className="main-content">
                //       <h5 className="work-type">{item?.job_type}</h5>
                //       <p className="desc">
                //         <div dangerouslySetInnerHTML={{__html: item?.description}} />

                //         {/* <Description letters={100} content={item?.description} /> */}
                //         </p>
                //     </div>
                //     <div className="recent-job-info">
                //       <a className='btn-theme btn-sm' href={item?.web_link} target="_blank">View Details</a>
                //       {/* <Link className="btn-theme btn-sm" to="/job-detail"></Link> */}
                //     </div>
                //   </div>
                //   </Link>
                //   {/*== End Recent Job Item ==*/}
                // </div>
              )
            })}

          </div> : <div className='d-flex justify-content-center align-items-center'>
            <img className='no-data-img' src={noData} alt="No Data" />
          </div>}
        </>}

        {pagination?.total_pages > 1 ? <div className="row">
          <div className="col-lg-12">
            <div className="pagination-area d-flex justify-content-between align-items-center">
              <nav>
                <ul className="page-numbers d-inline-flex">
                  {pageNumbers.map((page, index) => {
                    if (page === '...') {
                      return (
                        <li key={`ellipsis-${index}`}>
                          <span className="page-number">...</span>
                        </li>
                      )
                    }
                    return (
                      <li key={page} onClick={() => gotToNextPage({ current_page: page, per_page: pagination?.per_page })}>
                        <span className={`page-number ${page === Number(pagination?.current_page) ? 'active' : ''}`}>{page}</span>
                      </li>
                    )
                  })}

                  <li>
                    <span
                      className="page-number next"
                      onClick={() => {
                        if (pagination?.current_page < pagination?.total_pages) {
                          gotToNextPage({
                            current_page: Number(pagination.current_page) + 1,
                            per_page: pagination?.per_page
                          })
                        }
                      }}
                    >
                      <FaArrowRight />
                    </span>
                  </li>
                </ul>
              </nav>
              <div className='mt-2'>
                <label className='me-2'>Results Per Page: </label>
                <select value={pagination?.per_page} onChange={(e) => {
                  gotToNextPage({ per_page: e.target.value, current_page: pagination?.current_page })
                }}>
                  <option value="12">12</option>
                  <option value="16">16</option>
                  <option value="20">20</option>
                  <option value="24">24</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div> : null}
      </div>
    </section>

  )
}

export default JobLisit